export default "__VITE_ASSET__52PlWeVC__"